import React,{useReducer} from 'react'
import CartContext from './Cart-Context'
const defalutState={
  items:[],
  totalAmount:0
}
const cartReducer=(state,action)=>{
  if(action.type==="ADD"){
    // const updateItem=state.items.concat(action.item)
    const existingCartItemIndex=state.items.findIndex((item)=>item.id===action.item.id)
    const existingCartItem=state.items[existingCartItemIndex]
    // let updatedItem;
    let updatedItems;
    if(existingCartItem){
     const updatedItem={
        ...existingCartItem,
        amount:existingCartItem.amount+action.item.amount
      }
      updatedItems=[...state.items];
      updatedItems[existingCartItemIndex]=updatedItem
      console.log(updatedItems)
    }else{
      updatedItems=state.items.concat(action.item)
    }
    const updateTotalAmount=state.totalAmount+action.item.price*action.item.amount
    return {
      items:updatedItems,
      totalAmount:updateTotalAmount
    }
  }
  if(action.type==='REMOVE'){
    console.log("action remove")
    const existingCartItemIndex=state.items.findIndex((item)=>item.id===action.id)
    const existingItem=state.items[existingCartItemIndex];
    console.log(existingItem)
    const updatedTotalAmount=state.totalAmount-existingItem.price;
    let updatedItems;
    if(existingItem.amount===1){
      updatedItems=state.items.filter(item=>item.id!==action.id);
    }else{
      const updatedItem={...existingItem,amount:existingItem.amount-1};
      updatedItems=[...state.items];
      updatedItems[existingCartItemIndex]=updatedItem;
    }
    return{
      items:updatedItems,
      totalAmount:updatedTotalAmount
    }
  }
  return defalutState
}

export default function CartProvider(props) {
  const[cartState,dispatchCartState]=useReducer(cartReducer,defalutState)
    const addItemToCartHandler=item=>{
      dispatchCartState({
        type:"ADD",
        item:item
      })
    };
    const removeItemFromCartHandler=id=>{
      dispatchCartState({
        type:"REMOVE",id:id
      })
    };
    const cartContext ={
        items:cartState.items,
        totalAmount:cartState.totalAmount,
        addItem:addItemToCartHandler,
        removeItem:removeItemFromCartHandler

    }
  return (
    <CartContext.Provider value={cartContext}>
      {props.children}
    </CartContext.Provider>
  )
}
